<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-22 15:34:52
 * @FilePath: \mrc-ess-fronted\src\components\TimeWidget.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-07-01 16:03:21
-->
<template>
  <v-sheet
    color="white"
    class="pa-1 d-flex flex-column flex-grow-1"
    height="300"
    :width="showDay ? 320 : 290"
  >
    <v-row
      justify="start"
      col="12"
      class="pa-1 pt-3 d-flex flex-nowrap justify-center text-center"
      style="height: 50px"
    >
      <v-col md="3" v-if="showDay" class="pa-0 text-center numberInput">
        <v-text-field
          dense
          class="text-center"
          hide-details
          single-line
          :maxlength="2"
          suffix="Day"
          @keyup="onChange('day')"
          @blur="onBlur('day')"
          placeholder="Day"
          v-model="day"
        ></v-text-field>
      </v-col>
      <v-col md="1" v-if="showDay" class="pa-0"></v-col>
      <v-col :md="showDay ? 3 : 4" class="pa-0 numberInput">
        <v-text-field
          dense
          :reverse="!onlyShowHour"
          hide-details
          single-line
          :maxlength="2"
          @keyup="onChange('hour')"
          @blur="onBlur('hour')"
          class="text-center"
          placeholder="HH"
          v-model="hour"
        ></v-text-field>
      </v-col>
      <v-col
        :md="showDay ? 1 : 1"
        class="align-self-center pa-0"
        v-if="!onlyShowHour"
        >:</v-col
      >
      <v-col
        :md="showDay ? 3 : 4"
        class="pa-0 numberInput"
        v-if="!onlyShowHour"
      >
        <v-text-field
          dense
          single-line
          :maxlength="2"
          @keyup="onChange('min')"
          @blur="onBlur('min')"
          hide-details
          class="text-center"
          placeholder="MM"
          v-model="minute"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row
      class="d-flex flex-nowrap justify-center pa-1"
      style="height: calc(100% - 50px)"
    >
      <v-col
        md="3"
        ref="day"
        v-if="showDay"
        class="pa-1 scroll_content_y text-center fill-height"
        style="border-bottom: 1px solid var(--main-border-color)"
      >
        <v-btn
          outlined
          v-for="i in allday"
          :color="i == day ? 'primary' : 'grey lighten-2'"
          class="text-center mt-1 text-block"
          @click="setDay(i)"
          :key="i"
          >{{ "+" + i }}</v-btn
        >
      </v-col>
      <v-col md="1" class="pa-0" v-if="showDay"></v-col>
      <v-col
        :md="showDay ? 3 : 4"
        ref="hours"
        class="pa-1 scroll_content_y text-center fill-height"
        style="border-bottom: 1px solid var(--main-border-color)"
      >
        <v-btn
          :text="hour == '00' ? false : true"
          class="text-center mt-1 pa-1 text-block ma-auto"
          @click="setHour('00')"
          :disabled="isCanSelect('hour', '00')"
          depressed
          :key="'00'"
          :color="
            hour == '00' ? 'primary lighten-4 text--primary' : 'text--primary'
          "
          >00</v-btn
        >
        <v-btn
          v-for="i in 23"
          :text="hour == (i >= 10 ? i : '0' + i) ? false : true"
          class="text-center mt-1 pa-1 text-block"
          :key="i >= 10 ? i : '0' + i"
          depressed
          :disabled="isCanSelect('hour', i >= 10 ? i : '0' + i)"
          :color="
            hour == (i >= 10 ? i : '0' + i)
              ? 'primary lighten-4 text--primary'
              : 'text--primary'
          "
          @click="setHour(i >= 10 ? i : '0' + i)"
          >{{ i >= 10 ? i : "0" + i }}</v-btn
        >
      </v-col>
      <v-col :md="showDay ? 1 : 1" class="pa-0" v-if="!onlyShowHour"></v-col>
      <v-col
        :md="showDay ? 3 : 4"
        ref="minutes"
        v-if="!onlyShowHour"
        class="pa-1 scroll_content_y fill-height text-center"
        style="border-bottom: 1px solid var(--main-border-color)"
      >
        <v-btn
          :text="minute == '00' ? false : true"
          class="text-center mt-1 pa-1 text-block"
          @click="setMinute('00')"
          :disabled="isCanSelect('min', '00')"
          depressed
          :key="'00'"
          :color="
            minute == '00' ? 'primary lighten-4 text--primary' : 'text--primary'
          "
          >00</v-btn
        >
        <v-btn
          v-for="i in 59"
          :text="minute == (i >= 10 ? i : '0' + i) ? false : true"
          class="text-center mt-1 pa-1 text-block"
          :key="i >= 10 ? i : '0' + i"
          :disabled="isCanSelect('min', i >= 10 ? i : '0' + i)"
          depressed
          :color="
            minute == (i >= 10 ? i : '0' + i)
              ? 'primary lighten-4 text--primary'
              : 'text--primary'
          "
          @click="setMinute(i >= 10 ? i : '0' + i)"
          >{{ i >= 10 ? i : "0" + i }}</v-btn
        >
      </v-col>
    </v-row>
  </v-sheet>
</template>
<script>
export default {
  name: "TimeWidget",
  props: {
    isEnd: { default: false, type: Boolean },
    onlyShowHour: { default: false, type: Boolean },
    min: { default: "", type: [String, Number] },
    max: { default: "", type: [String, Number] },
    defaultTime: { default: "", type: [String, Number] },
    showDay: { default: false, type: Boolean },
    curDay: { default: 0, type: Number },
    selectAbleHour: { default: 0, type: Number },
    selectAbleMinute: { default: 0, type: Number },
    startTime: { default: 0, type: Number },
    endTime: { default: 1440, type: Number },
  },
  data() {
    return {
      allday: 30,
      day: 0,
      minSelect1: [0, 15, 30, 45],
      minSelect2: [0, 30],
      hour: "00",
      minute: "00",
      time: "00:00",
      i: 0,
      TimeMinute: 0,
    };
  },
  watch: {
    curDay(val) {
      // console.log(val);
    },
    time(val) {
      this.$emit("change", val, this.TimeMinute);
    },

    // defaultTime(val) {
    //   console.log(val);
    //   this.time = this.$timeMachine(val);
    //   this.day = Math.floor(Number(val) / (24 * 60));
    //   this.hour = Math.floor((Number(val) - this.day * (24 * 60)) / 60);
    //   this.minute = Number(val) - this.day * (24 * 60) - this.hour * 60;
    //   this.hour = this.hour >= 10 ? this.hour : "0" + this.hour;
    //   this.minute = this.minute >= 10 ? this.minute : "0" + this.minute;
    //   this.TimeMinute = this.timeMachine(this.day, this.hour, this.minute);
    // }
  },
  mounted() {
    // if (this.defaultTime) {
    //   let val = this.defaultTime;
    //   this.time = this.$timeMachine(val);
    //   this.day = Math.floor(Number(val) / (24 * 60));
    //   this.hour = Math.floor((Number(val) - this.day * (24 * 60)) / 60);
    //   this.minute = Number(val) - this.day * (24 * 60) - this.hour * 60;
    //   this.hour = this.hour >= 10 ? this.hour : "0" + this.hour;
    //   this.minute = this.minute >= 10 ? this.minute : "0" + this.minute;
    //   this.TimeMinute = this.timeMachine(this.day, this.hour, this.minute);
    // }
  },
  methods: {
    isCanSelect: function (type, num) {
      num = Number(num);
      if (this.curDay == 1) {
        // console.log("sdsds");
        return false;
      }
      if (!this.min && !this.max) {
        return false;
      } else {
        // console.log(this.curDay);
        if (this.isEnd) {
          if (!this.min) return false;
          if (this.day > 0) return false;
          let min_hour = Math.floor(
            (Number(this.min) - this.day * (24 * 60)) / 60
          );
          let min_minute =
            Number(this.min) - this.day * (24 * 60) - min_hour * 60;
          if (type == "hour") {
            if (this.minute < min_minute) {
              if (num >= min_hour) {
                return false;
              } else {
                return true;
              }
            }
            if (this.minute >= min_minute) {
              if (num >= min_hour) {
                return false;
              } else {
                return true;
              }
            }
          }
          if (type == "min") {
            if (Number(this.hour) == min_hour) {
              if (num >= min_minute) {
                return false;
              } else {
                return true;
              }
            } else if (Number(this.hour) > min_hour) {
              return false;
            } else {
              return true;
            }
          }
        } else {
          if (!this.max) return false;
          let day = Math.floor(Number(this.max) / (24 * 60));
          if (day > 0) return false;
          let max_hour = Math.floor(
            (Number(this.max) - this.day * (24 * 60)) / 60
          );
          let max_minute =
            Number(this.max) - this.day * (24 * 60) - max_hour * 60;
          if (type == "hour") {
            if (this.minute > max_minute) {
              if (num < max_hour) {
                return false;
              } else {
                return true;
              }
            }
            if (this.minute <= max_minute) {
              if (num <= max_hour) {
                return false;
              } else {
                return true;
              }
            }
          }
          if (type == "min") {
            if (Number(this.hour) < max_hour) {
              return false;
            } else if (Number(this.hour) == max_hour) {
              if (num <= max_minute) {
                return false;
              } else {
                return true;
              }
            } else {
              return true;
            }
          }
        }
      }
    },
    timeMachine: function (day, hour, minute) {
      return Number(day) * 60 * 24 + Number(hour) * 60 + Number(minute);
    },
    onBlur: function (type) {
      switch (type) {
        case "day":
          if (this.day) {
            this.setDay(this.day);
          } else {
            this.setDay("00");
          }

          break;
        case "hour":
          if (this.hour == "") {
            this.hour == "00";
          }
          if (Number(this.hour) >= 10) {
            this.setHour(this.hour);
          } else {
            this.setHour("0" + Number(this.hour));
          }
          break;
        case "min":
          if (this.minute == "") {
            this.minute == "00";
          }
          if (Number(this.minute) >= 10) {
            this.setMinute(this.minute);
          } else {
            this.setMinute("0" + Number(this.minute));
          }
          break;
        default:
          break;
      }
    },
    onChange: function (type) {
      switch (type) {
        case "day":
          if (this.day) {
            if (isNaN(this.day)) {
              this.day = 0;
            } else {
              if (Number(this.day) > this.allday) {
                this.day = this.allday;
              }
              if (Number(this.day) < 0) {
                this.day = 0;
              }
            }
          }
          break;
        case "hour":
          if (this.hour) {
            if (isNaN(this.hour)) {
              this.hour = 0;
            } else {
              if (Number(this.hour) > 23) {
                this.hour = 23;
              }
              if (Number(this.hour) < 0) {
                this.hour = 0;
              }
            }
          }
          break;
        case "min":
          if (this.minute) {
            if (isNaN(this.minute)) {
              this.minute = 0;
            } else {
              if (Number(this.minute) > 59) {
                this.minute = 59;
              }
              if (Number(this.minute) < 0) {
                this.minute = 0;
              }
            }
          }
          break;
        default:
          break;
      }
    },
    setDay: function (day) {
      if (this.day == day) {
        this.day = 0;
      } else {
        this.day = day;
      }
      this.time =
        this.day == 0
          ? this.hour + ":" + this.minute
          : "(+" + this.day + "day)" + this.hour + ":" + this.minute;
      this.TimeMinute = this.timeMachine(this.day, this.hour, this.minute);
      // 滾動
      if (this.$refs["day"] && this.$refs["day"].scrollHeight) {
        let scroll = this.$refs["day"].scrollHeight;
        this.$refs["day"].scrollTo(
          0,
          (scroll / this.allday) * Number(day) - (scroll / this.allday) * 3
        );
      }
    },
    setHour: function (hour) {
      this.hour = hour;
      this.time =
        this.day == 0
          ? this.hour + ":" + this.minute
          : "(+" + this.day + "day)" + this.hour + ":" + this.minute;
      this.TimeMinute = this.timeMachine(this.day, this.hour, this.minute);
      // 滾動
      if (this.$refs["hours"] && this.$refs["hours"].scrollHeight) {
        let scroll = this.$refs["hours"].scrollHeight;
        this.$refs["hours"].scrollTo(
          0,
          (scroll / 24) * Number(hour) - (scroll / 24) * 2
        );
      }
    },
    setMinute: function (minute) {
      this.minute = minute;
      this.time =
        this.day == 0
          ? this.hour + ":" + this.minute
          : "(+" + this.day + "day)" + this.hour + ":" + this.minute;
      this.TimeMinute = this.timeMachine(this.day, this.hour, this.minute);
      // 滾動
      if (this.$refs["minutes"] && this.$refs["minutes"].scrollHeight) {
        let scroll = this.$refs["minutes"].scrollHeight;
        this.$refs["minutes"].scrollTo(
          0,
          (scroll / 60) * Number(minute) - (scroll / 60) * 2 - 1
        );
      }
    },
  },
};
</script>
<style >
.numberInput .v-text-field input {
  text-align: center !important;
  line-height: inherit !important;
}
</style>